import {where,groupBy,pluck,find,contains,filter} from 'underscore';
import { GENERAL_FRACTURE_VALIDATION } from '../../../constants/Constants';
import $ from "jquery";
import { getExtraFieldJson } from './generalFracture';

export const getSelectedOptions = (inputObj, validationData) => {

    var keys1 = Object.keys(inputObj);
    var keys2;
    var value2;
    var value3;
    var arr3;
    var value4;
    var f;
    
        keys1.forEach( function(value, array, index) {
            if(value == undefined) {
                return;
            }
            if(inputObj[value] == undefined) {
                return;
            }
            keys2 = Object.keys(inputObj[value]);
            value2 = value;
            keys2.forEach( function(v2, a2, i2) {
                // console.log('Sub opt is ' + v2);
                arr3 = inputObj[value2][v2];
                value3 = v2;
                //Search for suboptions found in this list
                arr3.forEach(function (v3,a3,i3) {
                    value4 = v3;
                    // console.log(v3);
                    /*obj[62].options[value3].subOpts.forEach( function(v4,a4,i4) {
                        if(value4 === parseInt(v4.suboptionId)) {
                            v4.selected = true;
                        }
                    });*/
                    /*f = _.find(obj, function(a){
                            return a.suboptionId === v3;
                        });*/
                    f = where(validationData,{subOptionId:v3});
                    if(f.length > 0) {
                        f[0].selected = true;
                    }
                }) ;
            });
        });
        
        var selectedFilter = {selected:true};
        validationData = where(validationData, selectedFilter);
        
        return validationData;
    }
    
export const validateGeneralFractureAnnotation = (inputObj, annotations, validationData,gf_location,gf_bodyPart) => {
    // console.log("Value is");    
    // console.log(gf_location);
    //     console.log(gf_bodyPart);
        var selectedData = null;
        
        var annotationIdChk = contains(annotations, 54);
        
        if(!annotationIdChk) {
            return null;
        }
        
        selectedData = getSelectedOptions(inputObj, validationData);
        
        if(selectedData == undefined || selectedData.length ==0) {
            return {error:1, message:GENERAL_FRACTURE_VALIDATION._iselectOptionOrRemoveAnnotation};
        }
        
        var result = validateGfGroup1(selectedData,gf_location,gf_bodyPart);
        
        if(result != null) {
            return result;
        }
        
        result = validteGfGroup2(selectedData);
        if(result != null) {
            return result;
        }
        
        result = validateGfGroup3(selectedData);
        if(result != null) {
            return result;
        }
        
        result = validateGfGroup4(selectedData);
        if(result != null) {
            return result;
        }
        
        result = validateGfGroup5(selectedData);
        if(result != null) {
            return result;
        }
        
        result = validateGfGroup6(selectedData);
        if(result != null) {
            return result;
        }
        
        result = validateGfGroup7(selectedData);
        if(result != null) {
            return result;
        }
        
        result = validateGfGroup8(selectedData);
        if(result != null) {
            return result;
        }
        
        result = validateGfGroup9(selectedData);
        if(result != null) {
            return result;
        }
        
        return null;
    }
    
    function validateGfGroup1(selectedData,gf_location,gf_bodyPart) {
        var groupData = where(selectedData, {groupNumber:1});
        // console.log("GF LOCATION IS ");
        // console.log(gf_location);
        //console.log(getExtraFieldJson());
        var locationVal = $('#txtLocation').val();
        
        if((locationVal  == undefined || locationVal == null) && gf_location != ""){
            $('#txtLocation').val(gf_location);
            locationVal = gf_location;
        }	
        
        if(locationVal !== undefined && (locationVal == null || locationVal.trim().length == 0)) {
            $('#txtLocation').focus();
            return {error:1, message:GENERAL_FRACTURE_VALIDATION._ienterPlasterLocation};
        }
        
        if(locationVal === undefined ) {
            $('#txtLocation').focus();
            return {error:1, message:GENERAL_FRACTURE_VALIDATION._ienterPlasterLocation};
        }
    
        var data1 = where(groupData, {pathalogyOptionName:'Area'});
        if(data1.length == 0) {
            return {error:1, message:GENERAL_FRACTURE_VALIDATION._iselectOneFromPlaster};
        }
        
        data1 = where(groupData,{pathalogyOptionName:' '});
        if(data1.length == 0) {
            return {error:1, message:GENERAL_FRACTURE_VALIDATION._iselectOneFromCastOrSlab};
        }
        return null;
    }
    
    function validteGfGroup2(selectedData) {
        var groupData = filter(selectedData, {groupNumber:2})
        
        var group1 = [1738729,1738730];
        var group2 = [1738732,1738734,1738736];
        var group3 = [1738738];
        
        var g1 = filter(groupData, function(o) {return contains(group1, o.suboptionAssetId)});
        var g2 = filter(groupData, function(o) {return contains(group2, o.suboptionAssetId)});
        var g3 = filter(groupData, function(o) {return contains(group3, o.suboptionAssetId)});
        
        if(g3.length > 0 ) {
            if(g1.length > 0 || g2.length > 0) {
                return {error:1, message:GENERAL_FRACTURE_VALIDATION._iUnselectDisplacemetNil};
            }
            return null;
        }
        
        /*if(g1.length == 0) {
            return {error:1, message:_iselectOneOfDisplacementOrAvulusionFracture};
        }*/
        
        if(g1.length > 1) {
            return {error:1, message:GENERAL_FRACTURE_VALIDATION._iselectOneFromAvulusionFracture};
        }
        
        if(g2.length > 1) {
            return {error:1, message:GENERAL_FRACTURE_VALIDATION._iselectEitherUndisplacedOrMinimalOrSignificant};
        }
    }
    
    function validateGfGroup3(selectedData) {
        var group1 = [1738740,
            1738742,
            1738744,
            1738746,
            1738748,
            1738750,
            1738752];
        var group2 = [1738754];
        
        var groupData = where(selectedData, {groupNumber:3});
        
        var g1 = filter(groupData, function(o) {return contains(group1, o.suboptionAssetId)});
        var g2 = filter(groupData, function(o) {return contains(group2, o.suboptionAssetId)});
        
        if(g1.length > 0 && g2.length > 0) {
            return {error:1, message:GENERAL_FRACTURE_VALIDATION._iUnselectTypeNil};
        }
        return null;
    }
    
    function validateGfGroup4(selectedData) {
        var groupData = where(selectedData, {groupNumber:4});
        
        var group1 = [1738756];
        var group2 = [1738758 ,1738760 ,1738762 ,1738764];
        var group3 = [1738766];
        var group4 = [1738762,1738764];
        var group5 = [1738758,1738760];
        
        var g1 = filter(groupData, function(o) {return contains(group1, o.suboptionAssetId)});
        var g2 = filter(groupData, function(o) {return contains(group2, o.suboptionAssetId)});
        var g3 = filter(groupData, function(o) {return contains(group3, o.suboptionAssetId)});
        var g4 = filter(groupData, function(o) {return contains(group4, o.suboptionAssetId)});
        var g5 = filter(groupData, function(o) {return contains(group5, o.suboptionAssetId)});
        
        if(g3.length > 0) {
            if(g1.length > 0 || g2.length > 0) {
                return {error:1, message:GENERAL_FRACTURE_VALIDATION._iUnselectFragmentNil};
            }
        }
        
        if(g1.length > 0 && g2.length > 0) {
            return {error:1, message:GENERAL_FRACTURE_VALIDATION._iUnselectFragmentAligned};
        }
        /*if(g4.length >0 && g5.length <1){
            return {error:1, message:_iselectFragmentDisplacedOrImpacted};
        }*/
        if(g4.length > 1) {
            return {error:1, message:GENERAL_FRACTURE_VALIDATION._iselectWithOrWithoutIAE};
        }
        
        return null;
    }
    
    function validateGfGroup5(selectedData) {
        var groupData = where(selectedData, {groupNumber:5});
        var group1 = [1738770];
        var group2 = [1738772];
        
        var g1 = filter(groupData, function(o) {return contains(group1, o.suboptionAssetId)});
        var g2 = filter(groupData, function(o) {return contains(group2, o.suboptionAssetId)});
        
        if(g1.length > 0 && g2.length > 0) {
            return {error:1, message:'Please select only one option at a time from General Fracture->Extension'};
        }
        
        return null;
    }
    
    function validateGfGroup6(selectedData) {
        var groupData = where(selectedData, {groupNumber:6});
        var group1 = [1738774];
        var group2 = [1738776,1738777,1738778];
        
        var g1 = filter(groupData, function(o) {return contains(group1, o.suboptionAssetId)});
        var g2 = filter(groupData, function(o) {return contains(group2, o.suboptionAssetId)});
        
        if(g1.length > 0 && g2.length > 0) {
            return {error:1, message:GENERAL_FRACTURE_VALIDATION._iUnselectAbsentFromCallus};
        }
        
        return null;	
    }
    
    function validateGfGroup7(selectedData) {
        var groupData = where(selectedData, {groupNumber:7});
        
        var group1 = [1738779,1738780,1738781];
        var group2 = [1738782];
        
        var g1 = filter(groupData, function(o) {return contains(group1, o.suboptionAssetId)});
        var g2 = filter(groupData, function(o) {return contains(group2, o.suboptionAssetId)});
        
        return validateNilCheck(g1, g2, GENERAL_FRACTURE_VALIDATION._iUnselectNilAssociatedFindings);
    }
    
    function validateGfGroup8(selectedData) {
        var groupData = where(selectedData, {groupNumber:8});
        
        var group1 = [1738783,1738784,1738785,1738786,1738787];
        var group2 = [1738788];
        
        var g1 = filter(groupData, function(o) {return contains(group1, o.suboptionAssetId)});
        var g2 = filter(groupData, function(o) {return contains(group2, o.suboptionAssetId)});
        
        return validateNilCheck(g1, g2, GENERAL_FRACTURE_VALIDATION._iUnselectNilImplants);
    }
    
    function validateGfGroup9(selectedData) {
        var groupData = where(selectedData, {groupNumber:9});
        
        var group1 = [1738789
            ,1738790
            ,1738791
            ,1738792
            ,1738793];
        var group2 = [1738794];
        
        var g1 = filter(groupData, function(o) {return contains(group1, o.suboptionAssetId)});
        var g2 = filter(groupData, function(o) {return contains(group2, o.suboptionAssetId)});
        
        return validateNilCheck(g1, g2, GENERAL_FRACTURE_VALIDATION._iUnselectNilSoftTissue);
    }
    
    function validateNilCheck(nilGroup, otherGroup, message) {
        if(nilGroup.length > 0 && otherGroup.length > 0) {
            return {error:1, 'message':message};
        }
        
        return null;
    }